export enum RequestServiceInMemoryStoreNames {
  STORE_BRREG = 'STORE_BRREG',
  STORE_TODOS = 'STORE_TODOS',
}
